import { useEffect } from "react";
import Router from "next/router";

import { existsGaId, pageview } from "@/components/utils/gtag";

export default function usePageView() {
  useEffect(() => {
    if (!existsGaId) {
      return;
    }

    const handleRouteChange = (path) => {
      pageview(path);
    };

    Router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      Router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, []);
}
